import routes from './routes';
import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { DiscoverRoutePathNames, DiscoverRouteNames } from './enums';

const App = () => import('./App.vue');

export * from './enums';
export * from './routes';

export const route: RouteRecordRaw = {
  path: buildRootURL(DiscoverRoutePathNames.DISCOVER),
  name: DiscoverRouteNames.DISCOVER_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  children: routes,
};